// Widget alertes : dossiers en alerte ANAH (placeholder V1).
import { AlertTriangle } from "lucide-react";

export default function AlertesAnahWidget({ title }) {
  return (
    <div
      className="rounded-xl p-5 h-full flex flex-col"
      style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}
      data-testid="widget-alertes-anah"
    >
      <div className="flex items-center gap-2 mb-3">
        <AlertTriangle className="w-4 h-4" style={{ color: "var(--oh-warning-text, #fbbf24)" }} />
        <p className="text-sm font-semibold" style={{ color: "var(--oh-text)" }}>
          {title || "Alertes ANAH"}
        </p>
      </div>
      <p className="text-sm flex-1" style={{ color: "var(--oh-text-muted)" }}>
        Aucune alerte pour le moment.
      </p>
      <p className="text-xs mt-2" style={{ color: "var(--oh-text-muted)" }}>
        Widget en cours de spécification.
      </p>
    </div>
  );
}
